module.exports = __webpack_public_path__ + "img/dump.8a971be5.png";